import { useField } from 'react-final-form';

export const lightDemandFormField = 'receivedGrantedVerdictInPast12Months';

export const useIsLightDemandFormHelper = () => {
  const { input } = useField(lightDemandFormField);
  return Boolean(input.value);
};
